export const JSON_ONE = 
   
    
    [

        {
            "publishId": "PQU-040721140456-103",
            "acc_creation_datetime": "",
        
            "Data": {

                "AuthRR": [ ],
                "AuthVRR": [ ],
                "CaptureRR": [ ],
                "SaleRR": [ ],
                "RefundRI": [ ],
                "RequestSTPGoB": [ ],
                "ResponseRFPGoB": [ ],
                "VerificationRSTPGo": [ ],
                "VerificationRRFPGoB": [ ],
                "NoRRFPGoB": [ ],
                "AuthRP": [ ],
                "AuthRF": [ ],
                "AuthVRP": [ ],
                "AuthVRF": [ ],
                "CaptureRP": [ ],
                "CaptureRF": [ ],
                "SaleRP": [ ],
                "RefundRP": [ ],
                "RefundRF": [ ],
                "ReconciledWRGoB": [ ],
                "SettlementD": [ ],
                "ReconciledM": [ ],
                "MerchantPD": [ ],
                "CancelledBC": [ ],
                "Aborted": [ ],
                "HostTO": [ ],
                "AmountM": [ ]
            
            }
                
            }
        
        ]
            
        
        
    

    



